import { pipeLatLngs, pathLength } from './model';

const num = (v) => { const n = +String(v ?? '').replace(',', '.'); return v === '' || v == null || !Number.isFinite(n) ? null : n; };
export const isManhole = (f) => f?.type === 'manhole';
export const coverOf = (f) => num(f?.sw?.cover) ?? num(f?.elev?.v);
// invert elevation (Sohlhöhe) = cover (Deckelhöhe GOK) - invert depth (Abstichmaß)
export const invertOf = (f) => { const c = coverOf(f), d = num(f?.sw?.depth); return c != null && d != null ? c - d : null; };
// minimum slope rule of thumb 1:DN (DWA-A 110) -> ‰ = 1000 / DN
export const minSlope = (p) => num(p.sw?.min) ?? (num(p.dn) ? Math.round((1000 / +p.dn) * 10) / 10 : 5);

const endZ = (pt, fittings, manual) => {
  const m = num(manual);
  if (m != null) return m;
  return pt && !Array.isArray(pt) && pt.fid ? invertOf(fittings.find((f) => f.id === pt.fid)) : null;
};

export function pipeSlope(p, fittings = []) {
  if (p?.type !== 'sewer' || !p.points?.length) return null;
  const L = pathLength(pipeLatLngs(p, fittings));
  const zA = endZ(p.points[0], fittings, p.sw?.zA), zB = endZ(p.points[p.points.length - 1], fittings, p.sw?.zB);
  if (zA == null || zB == null || L < 0.01) return { L, zA, zB, pm: null };
  const pm = ((zA - zB) / L) * 1000, min = minSlope(p);
  return { L, zA, zB, pm, pct: pm / 10, min, status: pm < 0 ? 'neg' : pm < min ? 'low' : 'ok' };
}

export const fmtPm = (v) => `${v.toFixed(1).replace('.', ',')} ‰`;

// sewer attributes for exports (levels, slope, inspection)
const r3 = (v) => (v == null ? '' : Math.round(v * 1000) / 1000);
export const hasSewer = (project) => (project.fittings || []).some(isManhole) || (project.pipes || []).some((p) => p.type === 'sewer');
export const sewerFitCols = (f) => (isManhole(f) || f?.sw ? [r3(coverOf(f)), r3(num(f?.sw?.depth)), r3(invertOf(f))] : ['', '', '']);
export function sewerPipeCols(p, fittings, t) {
  const s = pipeSlope(p, fittings), ins = p.insp, items = ins?.items || [];
  const worst = items.length ? Math.min(...items.map((d) => +d.cls)) : '';
  return [r3(s?.zA), r3(s?.zB), s?.pm != null ? Math.round(s.pm * 10) / 10 : '', s?.status ? t[{ neg: 'swNeg', low: 'swLow', ok: 'swOk' }[s.status]] : '',
    ins ? t['siM_' + (ins.method || 'tv')] || '' : '', ins?.date ? new Date(`${ins.date}T12:00`).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '', worst,
    items.map((d) => `${d.st ?? ''} m ${d.code} ZK${d.cls}`).join(' | ')];
}
export const sewerPipeHead = (t) => [t.swFrom, t.swTo, `${t.swSlopeTitle} (‰)`, t.swStatus || 'Status', t.siMethodL || 'Methode', t.siDateL || 'Datum', t.siWorst, t.siTitle];
export const sewerFitHead = (t) => [t.swCover, t.swDepth, t.swInvert];
